import React from 'react';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';
import { getLightBorder } from 'Components/utils';
import SideColumn from 'Components/UI/ColumnLayout/SideColumn';
import Container from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ScenarioDetailsPicker/components/Container';
import Header from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ScenarioDetailsPicker/components/Header';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    ...getLightBorder(theme, { left: true }),
    overflow: 'auto',
  },
}));

const ScenarioDetailsRightColumn = () => {
  const classes = useStyles();
  return (
    <SideColumn>
      <Paper
        className={classes.root}
        elevation={0}
        rounded
      >
        <Header />
        <Container />
      </Paper>
    </SideColumn>
  );
};

export default ScenarioDetailsRightColumn;
